// extracted by mini-css-extract-plugin
module.exports = {"details":"InfoBar_details__UhKsl","item":"InfoBar_item__DI6nP","icon":"InfoBar_icon__r4VvW"};